module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.23809523809523,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 61.904761904761905,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#043f61"
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 58.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.07843137254902,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#043f61"
					},
					{
						"y": 86.27450980392157,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.47058823529412,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.58823529411765,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#09472e"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.31223628691983,
						"dataLabels": {
							"enabled": false,
							"format": "233"
						},
						"color": "#043f61"
					},
					{
						"y": 93.67088607594937,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.87341772151899,
						"dataLabels": {
							"enabled": false,
							"format": "213"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.38818565400844,
						"dataLabels": {
							"enabled": false,
							"format": "200"
						},
						"color": "#09472e"
					},
					{
						"y": 68.77637130801688,
						"dataLabels": {
							"enabled": false,
							"format": "163"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#043f61"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.28571428571429,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 35.714285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "89"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#0d4440"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#09472e"
					},
					{
						"y": 56.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#043f61"
					},
					{
						"y": 89.77777777777777,
						"dataLabels": {
							"enabled": false,
							"format": "202"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "192"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "179"
						},
						"color": "#09472e"
					},
					{
						"y": 59.55555555555555,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#043f61"
					},
					{
						"y": 54.166666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0d4440"
					},
					{
						"y": 41.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 29.166666666666668,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.23809523809523,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#043f61"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#0c4250"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0d4440"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#09472e"
					},
					{
						"y": 38.095238095238095,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.6470588235294,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#043f61"
					},
					{
						"y": 82.35294117647058,
						"dataLabels": {
							"enabled": false,
							"format": "70"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.47058823529412,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 61.1764705882353,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.03174603174604,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#043f61"
					},
					{
						"y": 83.73015873015873,
						"dataLabels": {
							"enabled": false,
							"format": "211"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.15873015873017,
						"dataLabels": {
							"enabled": false,
							"format": "202"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#09472e"
					},
					{
						"y": 59.523809523809526,
						"dataLabels": {
							"enabled": false,
							"format": "150"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.789473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.586206896551722,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.9215686274509776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.204081632653061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6877637130801704,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.72103004291845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.054054054054057,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.103286384976525,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.500000000000007,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1111111111111072,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.61797752808989,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.166666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8888888888888835,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.4170403587444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.950495049504955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.7708333333333375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.139664804469277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.352941176470591,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.662650602409634,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.411764705882348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.9682539682539653,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.809917355371903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.265402843601896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.970297029702973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.469387755102044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=21"
			},
			{
				"x": 9,
				"text": "30-39<br>n=36"
			},
			{
				"x": 15,
				"text": "40-49<br>n=51"
			},
			{
				"x": 21,
				"text": ">=50<br>n=237"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=10"
			},
			{
				"x": 34,
				"text": "30-39<br>n=28"
			},
			{
				"x": 40,
				"text": "40-49<br>n=90"
			},
			{
				"x": 46,
				"text": ">=50<br>n=225"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=24"
			},
			{
				"x": 59,
				"text": "30-39<br>n=42"
			},
			{
				"x": 65,
				"text": "40-49<br>n=85"
			},
			{
				"x": 71,
				"text": ">=50<br>n=252"
			}
		],
		"dataTable": {
			"MSM:<30": [
				21,
				20,
				19,
				16,
				14,
				13
			],
			"MSM:30-39": [
				36,
				36,
				33,
				30,
				29,
				21
			],
			"MSM:40-49": [
				51,
				49,
				44,
				39,
				36,
				30
			],
			"MSM:>=50": [
				237,
				233,
				222,
				213,
				200,
				163
			],
			"Non-MSM:<30": [
				10,
				10,
				7,
				7,
				5,
				2
			],
			"Non-MSM:30-39": [
				28,
				28,
				24,
				23,
				18,
				10
			],
			"Non-MSM:40-49": [
				90,
				89,
				84,
				80,
				72,
				51
			],
			"Non-MSM:>=50": [
				225,
				223,
				202,
				192,
				179,
				134
			],
			"Unknown:<30": [
				24,
				18,
				13,
				12,
				10,
				7
			],
			"Unknown:30-39": [
				42,
				40,
				30,
				28,
				24,
				16
			],
			"Unknown:40-49": [
				85,
				83,
				70,
				68,
				65,
				52
			],
			"Unknown:>=50": [
				252,
				242,
				211,
				202,
				196,
				150
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 339
// module chunks = 0